<template>
  <v-dialog
    v-model="show"
    max-width="600px"
  >
    <v-card
        v-for="notification in notifications"
        :key="notification.id"
        class="ma-0"
      >
      <v-alert
        :value="true"
        :type="notification.type"
        class="ma-0"
        :title="'Occurred '+notification.count+' times'"
      >
        {{notification.message}}
      </v-alert>
      <v-card-text class="caption" v-if="notification.body">{{notification.body}}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dismiss(notification)">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  data() {
    return {
      show: false,
    }
  },
  computed: {
    notifications () {
      if (Object.keys(this.$alerts.state.all).length > 0){
        this.show = true;
      } else {
        this.show = false;
      }
      return this.$alerts.state.all;
    },
  },
  methods: {
    dismiss(notification){
      this.$alerts.dismiss(notification.id);
    },
    cardColor(notification){
      if (notification.type == 'error'){
        return 'transparent';
      }
      return notification.type;
    },
  },
  watch: {
    show(show, from) {
      if (!show){
        for (let notification of Object.values(this.notifications)){
          this.dismiss(notification);
        }
      }
    }
  }
}
</script>